import { render, staticRenderFns } from "./IObserver.vue?vue&type=template&id=61f9e290"
import script from "./IObserver.vue?vue&type=script&lang=ts"
export * from "./IObserver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports